import React, { Component } from 'react';
import { Table, Button } from "reactstrap";
import { inject, observer } from 'mobx-react';
import { IconeDelete, IconeEditar } from '../../comum/components/Icones';


@inject("store")
@observer
export default class ServicosAcessoriosPopOver extends Component {
    constructor(props) {
        super(props);

        this.dataStore = this.props.dataStore;
        this.modalStore = this.props.store.modalStoreCustom;
    }

    render() {
        const { servicosAcessorios } = this.props;

        const height = servicosAcessorios.length > 5 ? '400px' : 'unset';

        return (
            <div className="popover__wrapper">
                <div>
                    <Button 
                        outline
                        className="collapseItem"
                    > 
                        <IconeEditar tamanho="sm" />
                    </Button>
                </div>
                <div className="popover__content_left" style={{ left: '-380px', height, overflow: 'auto' }} >
                    <Table className="mx-0 px-0 tabela" responsive hover striped borderless>
                        <tbody>
                            <tr>
                                <td className="small-title linha borda" colSpan="2" align="center">
                                    SERVIÇOS ACESSÓRIOS ADICIONADOS
                                </td>
                            </tr>
                            {servicosAcessorios.map((servico, index) => (
                                <tr key={index}>
                                    <td className="small-col" width="85%"><strong>{servico.Servico}</strong></td>
                                    {!servico.CodigoPai ? (
                                        <td width="15%" className="small-col-data botao" onClick={() => this.props.removeServico(servico)} >
                                            <IconeDelete tamanho="lg" className="m-0" />
                                        </td>
                                    ) : (
                                        <td width="15%" className="small-col-data" ></td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/ServicosAcessoriosPopOver.js